module.exports = __webpack_public_path__ + "static/media/bbva-profile.4ccd79d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bbva-profile.png
// module id = 1275
// module chunks = 0